import { useMemo } from 'react';
import { Card } from 'antd';
import RouterLinkButton from '../../common/components/RouterLinkButton';

const TEXT_CENTER: Record<string | number, string & {}> = {
  textAlign: 'center',
};

function SubmissionCard({
  title,
  children,
  formLink,
}: {
  title: string;
  children: React.JSX.Element | React.JSX.Element[];
  formLink: string;
}) {
  const actions = useMemo(
    () => [
      <RouterLinkButton key="submit" to={formLink}>
        Submit
      </RouterLinkButton>,
    ],
    [formLink]
  );
  return (
    <Card
      title={title}
      actions={actions}
      styles={{ body: TEXT_CENTER, header: TEXT_CENTER }}
    >
      {children}
    </Card>
  );
}

export default SubmissionCard;
